export const COMPANIES = {
  abbas_halim: { code: "abbas_halim", name: "Abbas Halim", englishName: "Abbas Halim", description: "Parent company · Blocks, slabs, and marble trading", color: "#514536", softColor: "#e6dec8" },
  refaq: { code: "refaq", name: "Refaq", englishName: "Refaq", description: "Marble furniture and accessories", color: "#514536", softColor: "#e6dec8" },
};

export function normalizeCompany(code) {
  return Object.prototype.hasOwnProperty.call(COMPANIES, code) ? code : "abbas_halim";
}

export function companyCodesForUser(user) {
  if (!user) return [];
  if (String(user.role || user.job_title || "").toLowerCase() === "owner") return Object.keys(COMPANIES);
  const assigned = Array.isArray(user.company_codes) ? user.company_codes : ["abbas_halim"];
  return [...new Set(assigned)].filter((code) => Object.prototype.hasOwnProperty.call(COMPANIES, code));
}

export function companyForUser(user, preferred) {
  const allowed = companyCodesForUser(user);
  return allowed.includes(preferred) ? preferred : allowed[0] || null;
}
